
import { Prop, Component, Vue, Ref } from 'vue-property-decorator';
import { DialogButtonItem } from '../type';

@Component
export default class FitDialog extends Vue {
  @Prop({ default: '' })title!: string;
  @Prop({ default: '' })content!: string;
  @Prop({ default: '' })htmlContent!: string;
  @Prop({ default: '' })align!: string;
  @Prop({ default: () => ([]) })btns!: DialogButtonItem[];
  /** 是否可以滚动 */
  @Prop({ default: false })scrollable!: boolean;
  @Ref('container') container!: HTMLDivElement;

  mounted() {
    // 禁止弹窗时，页面滑动
    // 需注意，若弹窗内有滚动条，同样会禁止了弹窗内的文案滚动。
    if (!this.scrollable) {
      this.container.addEventListener('touchmove', (e) => {
        e.preventDefault();
      });
    }
  }

  get finalTitle() {
    if (this.title && (!this.content && !this.htmlContent)) {
      // 如果有标题 但是没有内容 则展示标题
      return '';
    }
    return this.title;
  }

  get isAlign() {
    return this.btns.length >= 3;
  }

  get btnAlignStyle() {
    return this.isAlign ? 'weui-dialog__ft__vertical' : '';
  }

  get finalContent() {
    if (this.title && (!this.content && !this.htmlContent)) {
      // 如果有标题 但是没有内容 则展示标题
      return this.title;
    }
    return this.content || this.htmlContent;
  }

  getBtnType(index) {
    if (this.isAlign) {
      return index < this.btns.length - 1 ? 'weui-dialog__btn_primary' : 'weui-dialog__btn_default';
    }
    return index === this.btns.length - 1 ? 'weui-dialog__btn_primary' : 'weui-dialog__btn_default';
  }

  handleClick(index: number) {
    if (typeof this.btns[index].click === 'function') {
      this.btns[index].click?.();
    } else {
      this.$emit('click');
    }
  }
}

